const checkButtonPropsCombinations = ({ text, icon, leftIcon, rightIcon, ariaLabel, }) => {
    if (icon && (text || leftIcon || rightIcon)) {
        throw new Error('Using icon together with text, leftIcon or rightIcon is not allowed');
    }
    if (leftIcon && rightIcon) {
        throw new Error('Using leftIcon and rightIcon together is not allowed');
    }
    if (icon && !ariaLabel) {
        throw new Error(`Using icon without aria-label is not allowed, please describe it's function`);
    }
};

export { checkButtonPropsCombinations };
